<template>
    <div class="funfacts-inner">
        <div class="row">
            <div class="col-lg-3 col-6 col-sm-6">
                <div class="single-funfacts funfact-style-two">
                    <i class='bx bx-code-alt'></i>
                    <h3>8+</h3>
                    <br>
                    <p>Jahre Erfahrung</p>
                </div>
            </div>

            <div class="col-lg-3 col-6 col-sm-6">
                <div class="single-funfacts funfact-style-two">
                    <i class='bx bx-map'></i>
                    <h3>Wien</h3>
                    <br>
                    <p>Standort & persönlicher Kontakt</p>
                </div>
            </div>

            <div class="col-lg-3 col-6 col-sm-6">
                <div class="single-funfacts funfact-style-two">
                    <i class='bx bx-time-five'></i>
                    <h3>24h</h3>
                    <br>
                    <p>Reaktionszeit bei Anfragen</p>
                </div>
            </div>

            <div class="col-lg-3 col-6 col-sm-6">
                <div class="single-funfacts funfact-style-two">
                    <i class='bx bx-user-check'></i>
                    <h3>1:1</h3>
                    <br>
                    <p>Direkter Ansprechpartner</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Funfacts'
}
</script>